export default __webpack_public_path__ + "static/media/winner-child.af2c26c7.svg";